/** Пометка провайдера в журнале вызовов: Google-модели идут в Gemini API напрямую, не через OpenRouter. */
export const providerMark = (provider: string | null | undefined): string =>
  provider === "gemini" ? " · Google напрямую" : "";
